import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import MainTable from '../../../../components/Table/PaginationTable'
import DownloadButton from '../../../../components/common components/DownloadButton'
import FilterPanel from '../../../../components/common components/FilterPanel'
// import LinkedOrdersModal from '../../Orders/Outbox/LinkedOrderModal'
import { ActiveCompanyColumns } from '../../columns/columns';
import { deleteCompanyById, fetchActiveCompany } from '../../../../redux/adminSlice';
import { Button, Menu, MenuItem } from '@mui/material';
import FileOutlineIcon from '@mui/icons-material/Description';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterPanelForCompanies from '../../../../components/common components/FilterPanelForCompanies';
import WarningShipmentModalComponent from '../../../../components/Modals/WarningShipmentModalComponent';


const ActiveOrders = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const tableData = useSelector(state => state.admin.activeCompanyData) || []// console.log("****",state.order.data
  const isLoading = useSelector(state => state.admin.loading);
  const isError = useSelector(state => state.admin.error);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [filterCriteria, setFilterCriteria] = useState({
    searchText: ''
  });
  // const { data, loading, error } = useSelector((state) => state.tableData); // Assuming the state shape
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const totalRecords = useSelector(state => state.admin.paginationInfo?.totalRecords) || 0;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteCompanyId, setDeleteCompanyId] = useState("");
  const [actionType, setActionType] = useState('add');

  useEffect(() => {
    console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber},`);// ${token}
    // dispatch(resetOrderState())
    const queryParams = {
      type: 'active',
      pageSize,
      pageNumber,
      country: '',
      companyTypeName: '',
      searchText: ''
    };
    // dispatch(fetchActiveCompany(queryParams));
    // resetCompaniesState()
  }, [dispatch, pageSize, pageNumber]);
  // ====================Handle Methods ===============================

  const handleReset = () => {

    dispatch(fetchActiveCompany({
      type: 'active',
      pageSize,
      pageNumber,
      country: '',
      companyTypeName: '',
    }))
    console.log('Filter criteria reset');
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const deletecompFun = () => {
    // console.warn("In Delete", businessUnitId, actionType)
    dispatch(deleteCompanyById({ companyId: deleteCompanyId }))
      .then((response) => {
        if (response) {
          dispatch(
            dispatch(fetchActiveCompany({
              type: 'active',
              pageSize,
              pageNumber,
              country: '',
              companyTypeName: '',
            }))
          );
        }
        // console.log('deleted successfully:', response);
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
      });
  };

  const handleCreateCompanyBtnClick = () => {
    
    navigate('/create-company', {state: { actionType: 'add' }
  }); // Navigate to create order page

  }
  const acticeViewFun = (companyId, actionType) => {
    navigate(`/review-active-orders/${companyId}`); // Navigate to create order page
  }
  // Function to handle filter action
  const handleFilter = (criteria) => {
    console.log("check",criteria)
    const formattedCriteria = {
      searchText: criteria.search,
      country:criteria.countries.join(','),
      companyTypeId:criteria.companyTypeId
      // status:criteria.status,
      // fromDate: criteria.fromDate ? dayjs(criteria.fromDate).format('YYYY-MM-DD') : '',
      // toDate: criteria.toDate ? dayjs(criteria.toDate).format('YYYY-MM-DD') : ''
    };
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    console.log('Filter criteria:', criteria);
    const queryParams = {
      type: 'active',
      pageSize,
      pageNumber,
      country: formattedCriteria.country,
      companyTypeName: formattedCriteria.companyTypeId,
      searchText: formattedCriteria.searchText
    };
    dispatch(fetchActiveCompany(queryParams));
  };
  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);

  };
  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };
  // TO Delete  from the card
  const onDeleteCompnyBtnClick = (companyId, actionType) => {
    setIsDeleteModalOpen(true);
    setDeleteCompanyId(companyId);
  };
  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };
  const activeColumns = ActiveCompanyColumns(acticeViewFun, isCancelModalOpen,onDeleteCompnyBtnClick, t)
  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
            <button className="btn btn-primary greeen-btn md_btn" onClick={handleCreateCompanyBtnClick}>
              <span><ControlPointOutlinedIcon /></span> {t('orderOutboxcomponents.createNew')}
            </button>
          </div>
          <div>
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              // variant="contained"
              style={{ backgroundColor: '#6AA13C' }}
              className='btn btn-primary greeen-btn md_btn m-2 h-100'
              startIcon={<FileOutlineIcon />}
            >
              Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              {/* <MenuItem onClick={handleDownloadCatOpenModal}>Order Company Catalogue</MenuItem>
              <MenuItem onClick={handleDownloadCatOpenModal}>Order Product Catalogue</MenuItem> */}
              <MenuItem onClick={handleClose}>  <DownloadButton
                data={tableData}
                filename='Active Company List.xlsx'
                sheetname='Active company'
                forModule='Active Company' /></MenuItem>
            </Menu>

            <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
              <span><i className="bi bi-funnel"><FilterAltOutlinedIcon /></i></span> {t('orderOutboxcomponents.filters')}
            </button>

          </div>
        </div>
      </div>

      {isFilterPanelOpen && <FilterPanelForCompanies className='mb-3' onFilter={handleFilter} onReset={handleReset} />}
      <MainTable
        columns={activeColumns}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        // className="custom-table-class"
        recordCountText="records found"
      />
         {isDeleteModalOpen && (
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={deletecompFun}
        />
      )}
      {/* {linkModalOpen && <LinkedOrdersModal
        open={linkModalOpen}
        onClose={handleLinkCloseModal}
        actionType={actionType}
        newOrderId={newOrderId}
        linkedOrderList={linkedOrderList}
      />} */}
      {/* {isReasonModalOpen && <ReasonModalComponent
       open={isReasonModalOpen}
       handleClose={handleReasonCloseModal}
       action={actionType}
       reasonData={reasonData}
    />} */}
    </>
  )
}

export default ActiveOrders